export default __webpack_public_path__ + "static/media/logo-metis-mobile.4c026b4f.svg";